import React from 'react';
import clsx from 'clsx';
import {
    Input,
    InputAdornment,
    TextField,
    withStyles,
    IconButton,
    FormControl,
    InputLabel,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    button: {
        width: '120px',
        marginTop: '10px',
        marginRight: '10px'
    },
    submit: {
        width: '120px',
        marginTop: '10px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    },
    formControl: {
        width: '100%'
    }
});

const FormStep2 = props => {
    const {
        classes,
        translations,
        errors,
        values,
        handleChange,
        handleBlur,
        touched,
    } = props;

    const [value, setValue] = React.useState(false);

    const handleClickShowPassword = () => {
        setValue(!value);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <>
            <TextField
                label={translations['username'] || 'Username'}
                placeholder={translations['username'] || 'Username'}
                name="Username"
                fullWidth={true}
                value={values.Username}
                onChange={handleChange}
                onBlur={handleBlur}
                margin="dense"
                error={!!(errors.Username && touched.Username)}
            />
            <FormControl className={clsx(classes.margin, classes.formControl)}>
                <InputLabel htmlFor="in-category-1">{translations['password'] || 'Password'}</InputLabel>
                <Input
                    id="in-category-1"
                    type={value ? 'text' : 'password'}
                    name="Password"
                    value={values.Password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!(errors.Password && touched.Password)}
                    endAdornment={
                        <InputAdornment position="end">
                            <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                            >
                                {value ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>
                    }
                />
            </FormControl>
        </>
    );
};

export default withStyles(styles, { withTheme: true })(FormStep2);